import { Avatar, Body, Heading } from '@e2n/ui/v2';
import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { useTranslation } from 'react-i18next';
import { RotationsplanProgress } from '@/domain/mitarbeiter/features/rotationsplan/features/Details/RotationsplanProgress';
import { Location } from '@/domain/mitarbeiter/features/rotationsplan/components/Location';

export function Header({ rotationsplan }: { rotationsplan: Rotationsplan }) {
  const { t } = useTranslation();
  const { mitarbeiter } = rotationsplan;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2 items-center min-w-0">
        {mitarbeiter.imgUrl ? (
          <Avatar
            src={mitarbeiter.imgUrl}
            alt={mitarbeiter.getName()}
            fallbackInitials={mitarbeiter.getInitials()}
          />
        ) : (
          <Avatar type="initials" initials={mitarbeiter.getInitials()} />
        )}
        <Body className="truncate" weight="semibold">
          {mitarbeiter.getName()}
        </Body>
        <Location
          className="text-labels-secondary"
          standort={mitarbeiter.standort}
        />
      </div>
      <div className="flex flex-col gap-4">
        <Heading className="md:text-2xl">
          {t('domain.mitarbeiter.rotationsplan.title')}{' '}
          {rotationsplan.beruf.name}
        </Heading>
        <RotationsplanProgress rotationsplan={rotationsplan} />
      </div>
    </div>
  );
}
